var exports = {
  "k": "VoiceParticipantsList.module__container___eXpFUG",
};

module.exports = exports;
